var $9a8fbb5e6ca64f65$exports = {};
$9a8fbb5e6ca64f65$exports = {
    "help": `Ajuda`,
    "info": `Informa\xe7\xe3o`
};


export {$9a8fbb5e6ca64f65$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
